import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    pmCode: {
        name: () => '知识域',
    },

    rmName: {
        name: () => '知识模块名称',
        required: () => true,
    },

    rmNo: {
        name: () => '知识模块代码',
    },

    rmType: {
        name: () => '知识模块类型',
        required: () => true,
    },
})
